import {
  useUpdateZyusetuValueTemplateMutation,
  ZyusetuFieldKeyValueTemplateFragmentFragment
} from "@/graphql/graphql.ts";
import {z} from "zod";
import {FormProvider, useForm} from "react-hook-form";
import {zodResolver} from "@hookform/resolvers/zod";
import {useCallback} from "react";
import toast from "react-hot-toast";
import {Button, Dialog, DialogActions, DialogContent, Stack, Typography} from "@mui/material";
import {MyDialogTitle} from "@/components/dialog/MyDialogTitle.tsx";
import {FormTextField} from "@/components/form/FormTextField.tsx";

interface EditValueTemplateDialogProps {
  open: boolean;
  onClose: () => void;
  templateId: string;
  currentValue: ZyusetuFieldKeyValueTemplateFragmentFragment,
  onEditSuccess?: (value: ZyusetuFieldKeyValueTemplateFragmentFragment) => Promise<void>;
}

const schema = z.object({
  value: z.string().min(1),
  description: z.string().nullish(),
})

type schemaType = z.infer<typeof schema>

export function EditValueTemplateDialog(
  {open, currentValue, onClose, onEditSuccess, templateId}: EditValueTemplateDialogProps
) {
  const update = useUpdateZyusetuValueTemplateMutation()
  
  const form = useForm<schemaType>({
    values: {
      value: currentValue.value as string,
      description: currentValue.description
    },
    resolver: zodResolver(schema),
    mode: "onChange"
  })
  
  const onSubmit = useCallback(async (
    value: schemaType
  ) => {
    const toastId = toast.loading('更新中...')
    await update.mutateAsync({
      id: templateId,
      input: value
    }).then(
      (res) => {
        if (res.updateZyusetuValueTemplate) {
          toast.success('更新しました', {id: toastId})
          onClose()
          if (onEditSuccess) {
            onEditSuccess(res.updateZyusetuValueTemplate)
          }
        }
      }
    ).catch(
      () => {
        toast.error('更新に失敗しました', {id: toastId})
      }
    )
  }, [onClose, onEditSuccess, templateId, update])
  
  return <Dialog open={open} onClose={onClose} maxWidth={'sm'} fullWidth>
    <MyDialogTitle
      onClose={onClose}
    >
      編集
    </MyDialogTitle>
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <DialogContent>
          <Stack spacing={1}>
            
            <Typography variant={'formLabel'}>説明</Typography>
            <FormTextField name={'description'} control={form.control}
                           placeholder={'原状回復義務に関する取り決めがある場合'}/>
            <Typography variant={'formLabel'}>内容</Typography>
            <FormTextField lines={10} name={'value'} control={form.control}
                           placeholder={"居住年数にかかわらず、故意・過失、通常の使用に反する消耗の原状回復義務は借主負担とする"}/>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>キャンセル</Button>
          <Button type={'submit'} variant={'contained'} disabled={!form.formState.isValid}>更新</Button>
        </DialogActions>
      </form>
    </FormProvider>
  
  </Dialog>
  
}
